//export const API_URL = "https://globalapis.serviceplace.org.in/v1";
export const API_URL = "https://telehealthapi.serviceplace.org.in/v1";
export const ENCYPTION_KEY = "arogya#0987654321";
export const DEVICE_TYPE = "ANDROID";
export const DEVICE_TOKEN = "fpDnSllATPC2-RQURuALJy:APA91bHjjUGG7g88GHiu2qz1Gm9PCjCbEQvOTFpU74Ffcwt9JPSi-03eLb-LqWmKhJG2TZgZGaUuolEU7G_IBVKoo2OLf5Ge_KwsMpJ0_g0lFYnR5TjgoCTTokp9s-IpaoX1AUMI-hMu";
export const MAX_CERTICATE_UPLOAD = 5;
export const PAGINATION_LIMIT = 10;